import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import ProductDetail from './pages/ProductDetail';
import './App.css';
import LoginScreen from './pages/LoginScreen';
import AdminProductUpdateScreen from './pages/AdminProductUpdateScreen';
import { AuthProvider } from './components/AuthProvider';
import { CartProvider } from './components/CartProvider';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Checkout from './pages/Checkout';
import AdminOrders from './pages/AdminOrders';

import { NavbarHandle } from './types';

import { useRef } from 'react';
import About from './pages/About';
import OrderStatusPage from './pages/OrderStatus';
import AdminConfigScreen from './pages/AdminConfigScreen';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY_DEV!);

const App: React.FC = () => {

  const navbarRef = useRef<NavbarHandle>(null);

  return (
    <Elements stripe={stripePromise}>
      <AuthProvider>
      <CartProvider>
        <Router>
          <Navbar ref={navbarRef}/>
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/product/:id" element={<ProductDetail openCartDrawer={() => navbarRef.current?.openCart()}/>} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/admin/product/:id?" element={<AdminProductUpdateScreen />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/config" element={<AdminConfigScreen />} />
            <Route path="/order-status/:token" element={<OrderStatusPage />} />
          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
    </Elements>
  )
};

export default App;
